var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{style:(_vm.useStyle ? _vm.style : ''),attrs:{"to":{ name: this.routeName },"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }